import React from 'react';

interface EmptyBoxProps {
  width?: string;
  height?: string;
  className?: string;
  color?: string;
  margin?: string;
}

const EmptyBox: React.FC<EmptyBoxProps> = ({ 
  width = '4rem', 
  height = '4rem', 
  className = '',
  color = '#d1d5db',
  margin = '0 auto 1rem'
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      style={{ width, height, color, margin }} 
      className={className}
      fill="none" 
      viewBox="0 0 24 24" 
      stroke="currentColor"
    >
      <path 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        strokeWidth={2} 
        d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" 
      />
    </svg>
  );
};

export default EmptyBox; 